import {faSteeringWheel} from "@fortawesome/pro-regular-svg-icons";
import {facetIcons} from "../components/Facet.tsx";

export const truckFacetIcons = {
    drive: faSteeringWheel,
    ...facetIcons,
} as const;
export type TruckFacet = keyof typeof truckFacetIcons;